import { theme } from 'lib';
import styled from 'styled-components';

const LineStyle = styled.div`
  height: ${(props) => props.ht || '1px'};
  width: ${(props) => (props.ht ? '1px' : props.wid || '100%')};
  background: ${(props) => (props.dark ? (props.MAIN ? theme.MAIN : theme.SEC) : '#ddd')};
  margin: ${(props) => props.marg};
`;

const Line = (props) => <LineStyle {...props} />;

export default Line;
